import toast from 'react-hot-toast';
import { actions } from '../../context';
import {
    FETCH_PRACTICES_REQUEST,
    FETCH_PRACTICES_RESULT,
    FETCH_PRACTICE_REQUEST,
    SEARCH_PRACTICES_RESULT,
    SEARCH_PRACTICE_ERROR,
    GET_ALL_SHARD_REGIONS,
    GET_CURRENT_PAGE,
    GET_FIRST_ACTIVE_PRACTICE_ID,
    GET_FIRST_STALE_PRACTICE_ID,
    GET_PRACTICE_CONFIG,
    GET_PRACTICE_CONFIG_FORM,
    GET_SOME_PRACTICES,
    GET_LATEST_RUNTIME_EXTRACTION,
    GET_LATEST_RUNTIME_STAGING,
    GET_LATEST_RUNTIME_INTERMEDIATE,
    GET_LATEST_RUNTIME_INSTANCE_REPORT,
    GET_LATEST_RUNTIME_CONVERSIONPREP,
    GET_LATEST_RUNTIME_LEADS_GENERATION,
    PRACTICES_WITH_NOTIFICATIONS,
    PRACTICE_ERROR,
    PRACTICE_TAB_SELECTED,
    PRACTICE_TO_MUTE,
    USER_ASSIGNING_PRACTICE,
    SEARCHING_FOR_PRACTICES,
    SELECT_PRACTICE,
    SET_ACTIVE_TAB_PRACTICES,
    SET_ASSIGNED_USER,
    SET_BOOKMARKED,
    SET_CURRENT_PAGE,
    SET_DASHBOARD_STATS,
    SET_FILTER,
    SET_FIRST_ACTIVE_PRACTICE_ID,
    SET_FIRST_PRACTICE_READY,
    SET_FIRST_STALE_PRACTICE_ID,
    SET_INCLUDE_TEST_PRACTICES,
    SET_INCLUDE_DORMANT_PRACTICES,
    SET_INTERMEDIATE_ENTITY_COUNTS,
    SET_PRACTICE_ID,
    SET_PRACTICE_NOTIFICATIONS,
    SET_SEARCH_ASSIGNED_PRACTICES,
    SET_SEARCH_COMMUNICATIONS,
    SET_SEARCH_CUSTOM_IDS,
    SET_SEARCH_GROUPS,
    SET_SEARCH_NOTES,
    SET_SEARCH_PARTNER_OFFERINGS,
    SET_SEARCH_PRACTICE_PIMS,
    SET_RELATION_STEP2,
    REMOVE_RELATION_STEP2,
    UNSELECT_PRACTICE,
    UPDATE_PRACTICE_TAB,
    RESET_RELATION_STEP2,
    SET_SCHEDULE_MODAL_WORKING_PRACTICE,
    SET_RELATIONS_MODAL_WORKING_PRACTICE,
    SET_CONFIG_MODAL_WORKING_PRACTICE,
    GET_PRACTICE,
    SET_PRACTICE_GROUPS,
} from '../ActionTypes';

const initActions = function (services) {
    const axiosCall = services.axios.Axios();

    const searchingForPractices = (value) => {
        return {
            type: SEARCHING_FOR_PRACTICES,
            payload: value,
        };
    };

    const selectPracticeToMute = (practice) => {
        return {
            type: PRACTICE_TO_MUTE,
            payload: practice,
        };
    };

    const selectPracticeToAssignToUser = (practice) => {
        return {
            type: USER_ASSIGNING_PRACTICE,
            payload: practice,
        };
    };

    const selectPractice = (practice) => {
        return {
            type: SELECT_PRACTICE,
            payload: practice,
        };
    };
    // TODO: put into practices tab redux feature slice
    // TODO: get rid of practices tabs entirely
    const closePracticeTab = (practice, tabId) => {
        return async (dispatch) => {
            dispatch(unSelectPractice(practice, tabId));
            dispatch(actions.toggle.toggleEditingPractice(false));
        };
    };

    const unSelectPractice = (practice, tabId) => {
        return {
            type: UNSELECT_PRACTICE,
            payload: { practice, tabId },
        };
    };

    const practiceTabSelected = (tabId) => {
        return {
            type: PRACTICE_TAB_SELECTED,
            payload: tabId,
        };
    };

    const setBookmarked = (bool) => {
        return {
            type: SET_BOOKMARKED,
            payload: bool,
        };
    };

    const setIncludeTestPractices = (value = false) => {
        return {
            type: SET_INCLUDE_TEST_PRACTICES,
            payload: value,
        };
    }

    const setIncludeDormantPractices = (value = false) => {
        return {
            type: SET_INCLUDE_DORMANT_PRACTICES,
            payload: value,
        }
    }

    const setSearchNotes = (bool) => {
        return {
            type: SET_SEARCH_NOTES,
            payload: bool,
        };
    };

    const setOnlyShowAssigned = (bool) => {
        return {
            type: SET_SEARCH_ASSIGNED_PRACTICES,
            payload: bool,
        };
    };

    const setSearchGroups = (bool) => {
        return {
            type: SET_SEARCH_GROUPS,
            payload: bool,
        };
    };

    const setActiveTabPractices = (tab) => {
        return {
            type: SET_ACTIVE_TAB_PRACTICES,
            payload: tab,
        };
    };

    const getCurrentPage = (currentPage) => {
        return {
            type: GET_CURRENT_PAGE,
            payload: currentPage,
        };
    };

    const setCurrentPage = (currentPage) => {
        return {
            type: SET_CURRENT_PAGE,
            payload: currentPage,
        };
    };

    const setFilter = (filter) => {
        return {
            type: SET_FILTER,
            payload: filter,
        };
    };

    const getAllShardRegions = (allShardRegions) => {
        return {
            type: GET_ALL_SHARD_REGIONS,
            payload: allShardRegions,
        };
    };

    const fetchPracticeRequest = () => {
        return {
            type: FETCH_PRACTICE_REQUEST,
        };
    };

    const fetchPracticesRequest = () => {
        return {
            type: FETCH_PRACTICES_REQUEST,
        };
    };

    const fetchPracticesResult = (practices, totalPages, practiceTab) => {
        return {
            type: FETCH_PRACTICES_RESULT,
            payload: { practices, totalPages, practiceTab },
        };
    };

    const setFirstPracticeReady = (bool) => {
        return {
            type: SET_FIRST_PRACTICE_READY,
            payload: bool,
        };
    };

    const practiceError = (error) => {
        return {
            type: PRACTICE_ERROR,
            payload: error,
        };
    };

    const getSomePractices = (practiceData) => {
        return {
            type: GET_SOME_PRACTICES,
            payload: practiceData,
        };
    };

    const setDashboardStats = (stats) => {
        return {
            type: SET_DASHBOARD_STATS,
            payload: stats,
        };
    };

    const setCurrentPracticeId = (id) => {
        return {
            type: SET_PRACTICE_ID,
            payload: id,
        };
    };

    const setCurrentPractice = (practice = {}) => {
        return {
            type: GET_PRACTICE,
            payload: practice,
        };
    };

    //GET LATEST RUNTIME//////////////////////////////////////////////////////
    const setLatestRuntimeJobExtraction = (timeData) => {
        return {
            type: GET_LATEST_RUNTIME_EXTRACTION,
            payload: timeData,
        };
    };

    const setLatestRuntimeJobStaging = (timeData) => {
        return {
            type: GET_LATEST_RUNTIME_STAGING,
            payload: timeData,
        };
    };

    const setLatestRuntimeJobIntermediate = (timeData) => {
        return {
            type: GET_LATEST_RUNTIME_INTERMEDIATE,
            payload: timeData,
        };
    };

    const setLatestRuntimeInstanceReport = (timeData) => {
        return {
            type: GET_LATEST_RUNTIME_INSTANCE_REPORT,
            payload: timeData,
        };
    };

    const setLatestRuntimeConversionPrep = (timeData) => {
        return {
            type: GET_LATEST_RUNTIME_CONVERSIONPREP,
            payload: timeData,
        };
    };

    const setLatestRuntimeLeadsGeneration = (timeData) => {
        return {
            type: GET_LATEST_RUNTIME_LEADS_GENERATION,
            payload: timeData,
        };
    };

    const getPractice =
        (id, getForWorkflow = false) =>
            async () => {
                let params = {};
                if (getForWorkflow) params.getForWorkflow = true;
                return axiosCall.get('practices/' + id, { params: params });
            };

    let fetchPracticeCancel = new AbortController();
    const fetchPractice = (practiceId) => {
        return async (dispatch) => {
            try {
                fetchPracticeCancel.abort();
                fetchPracticeCancel = new AbortController();

                dispatch(fetchPracticeRequest);

                var response = await axiosCall.get(`practices/${practiceId}`, {
                    signal: fetchPracticeCancel.signal,
                });

                // TODO: put in better error handling

                if (response?.data?.data) {
                    const practice = response?.data?.data;

                    dispatch(setCurrentPracticeId(practice?.id));
                    dispatch(setCurrentPractice(practice));
                    dispatch(actions.toggle.toggleIsEditingPractice(false));
                    dispatch(selectPractice(practice));

                    return practice;
                }

                return '';
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    // TODO: put this into the practice workflow redux slice
    //#region Create New Practice Actions

    const createPractice = (payload) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.post('practices', payload);
                return response.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));

                toast(
                    () => (
                        <div className="text-light d-flex justify-content-between w-100">
                            Error: Something occurred during create practice
                            process!
                        </div>
                    ),
                    {
                        duration: 7500,
                        style: {
                            minWidth: '25vw',
                            background: 'red',
                        },
                    }
                );
            }
        };
    };

    const addOfferingStep2 = (offering) => {
        return {
            type: SET_RELATION_STEP2,
            payload: offering,
        };
    };

    const removeOfferingsStep2 = (partnerOfferingId) => {
        return {
            type: REMOVE_RELATION_STEP2,
            payload: partnerOfferingId,
        };
    };
    const resetOfferingsStep2 = (relations = []) => {
        return {
            type: RESET_RELATION_STEP2,
            payload: relations,
        };
    };
    //#endregion

    const editPractice = (payload) => async () =>
        axiosCall.patch('practices/' + payload.id, payload);

    const savePracticeInfo = (newPracticeInfo) => {
        return async (dispatch) => {
            try {
                await axiosCall.post(`practices`, newPracticeInfo);
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const saveEditedPracticeInfo = (editedPracticeInfo) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.patch(
                    `practices/` + editedPracticeInfo.id,
                    editedPracticeInfo
                );
                return response.data.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const updatePracticeTab = (practice) => {
        return {
            type: UPDATE_PRACTICE_TAB,
            payload: practice,
        };
    };

    /**
     * @deprecated
     */
    const saveBookmarkedPractice = (bookmarkedPractice) => {
        return async (dispatch) => {
            try {
                await axiosCall.patch(
                    `practices/${bookmarkedPractice}/bookmark`
                );
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const addPracticeBookmark = (practiceId) => {
        return async (dispatch) => {
            try {
                await axiosCall.post(`practices/${practiceId}/bookmark`);
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const removePracticeBookmark = (practiceId) => {
        return async (dispatch) => {
            try {
                await axiosCall.delete(`practices/${practiceId}/bookmark`);
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    let getPracticesCancel = new AbortController();
    const getPractices =
        (
            practiceTab = 'all',
            filter = '',
            onlyShowBookmarked = false,
            onlyShowAssigned = false,
            assignedFilterUser = null,
            includeTestPractices = false,
            includeDormantPractices = false,
            searchPracticeNotes = false,
            searchPracticeGroups = false,
            searchCustomIds = false,
            searchPartnerOfferings = false,
            searchPracticePims = false
        ) => {
            return async (dispatch) => {
                try {
                    getPracticesCancel.abort();
                    getPracticesCancel = new AbortController();
                    let params = {};
                    if (filter !== '') params.filter = filter;
                    if (onlyShowBookmarked === true) params.onlyShowBookmarked = true;
                    if (practiceTab.toLowerCase() === 'stale')
                        params.onlyShowStale = true;
                    if (practiceTab.toLowerCase() === 'manual_conversions')
                        params.onlyShowManualConversions = true;
                    if (practiceTab.toLowerCase() === 'conversions')
                        params.onlyShowConversions = true;
                    if (practiceTab.toLowerCase() === 'live')
                        params.onlyShowLive = true;
                    if (practiceTab.toLowerCase() === 'new') params.onlyShowNew = true;
                    if (practiceTab.toLowerCase() === 'muted')
                        params.onlyShowMuted = true;
                    if (practiceTab.toLowerCase() === 'dormant')
                        params.onlyShowDormant = true;
                    if (onlyShowAssigned === true) params.onlyShowAssigned = true;
                    if (assignedFilterUser !== null)
                        params.assignedAccountId = assignedFilterUser;
                    if (includeTestPractices === true)
                        params.includeTestPractices = true;
                    if (includeDormantPractices == true)
                        params.includeDormantPractices = true;
                    if (searchPracticeNotes === true) params.searchNotes = true;
                    if (searchPracticeGroups === true)
                        params.searchPracticeGroups = true;
                    if (searchCustomIds === true) params.searchCustomIds = true;
                    if (searchPartnerOfferings === true)
                        params.searchPartnerOfferings = true;
                    if (searchPracticePims === true) params.searchPracticePims = true;

                    let query = await axiosCall.get('v2/practices', {
                        params,
                        signal: getPracticesCancel.signal,
                    });
                    
                    dispatch({
                        type: SEARCH_PRACTICES_RESULT,
                        payload: query,
                    });

                    return query;
                } catch (error) {
                    if (error.name === 'CanceledError') {
                        return;
                    }
                    
                    dispatch({
                        type: SEARCH_PRACTICE_ERROR,
                        payload: error.message,
                    });
            }
        }
    }

    const getAllPracticeGroups = () => {
        return async (dispatch) => {
            let groups = await axiosCall.get('practices/groups');
            dispatch(setPracticeGroups(groups?.data || []));
        };
    };

    const setPracticeGroups = (groups = []) => {
        return {
            type: SET_PRACTICE_GROUPS,
            payload: groups,
        };
    };

    const fetchShardRegions = () => {
        return async (dispatch) => {
            let response = await axiosCall.get('regions');
            const allRegions = response.data;
            dispatch(getAllShardRegions(allRegions));
        };
    };

    const setAssignedUser = (practiceId, accountId) => {
        return async (dispatch) => {
            try {
                await axiosCall.post(`practices/${practiceId}/assign`, {
                    id: accountId,
                });
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const removeAssignedUser = (practiceId) => {
        return async (dispatch) => {
            try {
                await axiosCall.delete(`practices/${practiceId}/assign`);
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const setFirstActivePracticeId = (practiceId) => {
        return {
            type: SET_FIRST_ACTIVE_PRACTICE_ID,
            payload: practiceId,
        };
    };

    const getFirstActivePracticeId = (practiceId) => {
        return {
            type: GET_FIRST_ACTIVE_PRACTICE_ID,
            payload: practiceId,
        };
    };

    const setFirstStalePracticeId = (practiceId) => {
        return {
            type: SET_FIRST_STALE_PRACTICE_ID,
            payload: practiceId,
        };
    };

    const getFirstStalePracticeId = (practiceId) => {
        return {
            type: GET_FIRST_STALE_PRACTICE_ID,
            payload: practiceId,
        };
    };

    const setActiveInactive = (x, activeInactive) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.patch(`practices/` + x, {
                    active: activeInactive,
                });
                return response.data.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const getPracticeConfig = (config) => {
        return {
            type: GET_PRACTICE_CONFIG,
            payload: config,
        };
    };

    const getPracticeConfigForm = (form) => {
        return {
            type: GET_PRACTICE_CONFIG_FORM,
            payload: form,
        };
    };

    const getPracticeConfiguration = (practiceId) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.get(
                    `practices/${practiceId}/configuration`
                );
                //dispatch(getPracticeConfig(response.data.data));
                return response.data.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const getPracticeConfigurationForm = () => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.get(
                    `practices/configuration/empty`
                );
                dispatch(getPracticeConfigForm(response.data.data));
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const createPracticeInstaller = (practiceId) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.post(
                    `practices/${practiceId}/installer`
                );
                //no response for now
                return response.data.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const savePracticeConfiguration = (practiceId, config) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.patch(
                    `practices/${practiceId}/configuration`,
                    config
                );
                if (response.data.success) return true;
                return false;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    /**
     * Practice muting / unmuting
     */
    const mutePractice = (practiceId, payload) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.post(
                    `practices/${practiceId}/mute`,
                    {
                        ...payload,
                    }
                );
                return response.data.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const unmutePractice = (practiceId) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.delete(
                    `practices/${practiceId}/mute`
                );
                return response.data.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const deactivatePractice = (practiceId) => {
        return async (dispatch) => {
            try {
                await axiosCall.post(`practices/${practiceId}/deactivate`);
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const activatePractice = (practiceId) => {
        return async (dispatch) => {
            try {
                await axiosCall.post(`practices/${practiceId}/activate`);
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const setPracticeNotifications = (notifications) => {
        return {
            type: SET_PRACTICE_NOTIFICATIONS,
            payload: notifications,
        };
    };

    const triggerAgentRestart = (practiceId, message = '') => {
        return async (dispatch) => {
            try {
                await axiosCall.post(`practices/${practiceId}/restart`, {
                    message,
                });
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const triggerManualPracticeAttachmentSync = (
        message,
        practiceId,
        sourceFolder,
        isRecursive,
        includedFiles,
        excludedFiles,
        snapshotMode
    ) => {
        return async (dispatch) => {
            try {
                await axiosCall.post(`practices/${practiceId}/attachmentsync`, {
                    message,
                    sourceFolder,
                    isRecursive,
                    includedFiles,
                    excludedFiles,
                    snapshotMode,
                });
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const triggerManualPracticeAttachmentSyncFromIntermediate = (
        message,
        practiceId
    ) => {
        return async (dispatch) => {
            try {
                await axiosCall.post(`practices/${practiceId}/attachmentsyncbatchfromintermediate`, {
                    message
                });
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const terminateAttachmentSync = (practiceId, message = '') => {
        return async (dispatch) => {
            try {
                await axiosCall.post(`practices/${practiceId}/terminateattachmentsync`, {
                    message,
                });
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const triggerManualPracticeExtraction = (practiceId, message = '') => {
        return async (dispatch) => {
            try {
                await axiosCall.post(`practices/${practiceId}/extract`, {
                    message,
                });
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const terminateDataExtraction = (practiceId, message = '') => {
        return async (dispatch) => {
            try {
                await axiosCall.post(`practices/${practiceId}/terminateextraction`, {
                    message,
                });
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const triggerManualPracticeStagingLoad = (practiceId, message = '') => {
        return async (dispatch) => {
            try {
                await axiosCall.post(`practices/${practiceId}/staging`, {
                    message,
                });
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const triggerManualPracticeIntermediateLoad = (
        practiceId,
        message = ''
    ) => {
        return async (dispatch) => {
            try {
                await axiosCall.post(`practices/${practiceId}/intermediate`, {
                    message,
                });
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const triggerManualPracticeDaylightSync = (practiceId, message = '') => {
        return async (dispatch) => {
            try {
                await axiosCall.post(`practices/${practiceId}/daylightsync`, {
                    message,
                });
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const triggerManualPracticeReportingSync = (practiceId, message = '') => {
        return async (dispatch) => {
            try {
                await axiosCall.post(`practices/${practiceId}/reportingsync`, {
                    message,
                });
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const getLatestInstanceReportRuntime = (instanceId) => {
        return async (dispatch) => {
            try {
                let response = await axiosCall.get(
                    `ReportDelivery/InstanceReport?instanceId=${instanceId}`
                );

                if (response.data?.instanceReportRan?.length) {
                    return dispatch(
                        setLatestRuntimeInstanceReport(response.data)
                    );
                }

                return dispatch(
                    setLatestRuntimeInstanceReport({
                        instanceId: instanceId,
                        instanceReportRan: 'Runtime not found',
                    })
                );
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const triggerManualPracticeLeadsGeneration = (practiceId, message = '') => {
        return async (dispatch) => {
            try {
                await axiosCall.post(
                    `practices/${practiceId}/leadsgeneration`,
                    {
                        message,
                    }
                );
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const getLatestRuntime = (practiceId, jobType = '') => {
        return async (dispatch) => {
            try {
                const params = { jobType: jobType };
                let response = await axiosCall.get(
                    `practices/${practiceId}/latestruntimebyjobtype`,
                    { params }
                );

                switch (jobType) {
                    case 'Extraction':
                    case 'ExtractionInitiate':
                        if (Object.keys(response.data.data).length !== 0) {
                            return dispatch(
                                setLatestRuntimeJobExtraction(
                                    response.data.data
                                )
                            );
                        }

                        return dispatch(
                            setLatestRuntimeJobExtraction('Runtime not found')
                        );
                    case 'StagingLoad':
                        if (Object.keys(response.data.data).length !== 0) {
                            return dispatch(
                                setLatestRuntimeJobStaging(response.data.data)
                            );
                        }

                        return dispatch(
                            setLatestRuntimeJobStaging('Runtime not found')
                        );
                    case 'IntermediateLoad':
                        if (Object.keys(response.data.data).length !== 0) {
                            return dispatch(
                                setLatestRuntimeJobIntermediate(
                                    response.data.data
                                )
                            );
                        }

                        return dispatch(
                            setLatestRuntimeJobIntermediate('Runtime not found')
                        );
                    case 'ConversionPrep':
                        if (Object.keys(response.data.data).length !== 0) {
                            return dispatch(
                                setLatestRuntimeConversionPrep(
                                    response.data.data
                                )
                            );
                        }

                        return dispatch(
                            setLatestRuntimeConversionPrep('Runtime not found')
                        );
                    case 'LeadsGeneration':
                        if (Object.keys(response.data.data).length !== 0) {
                            return dispatch(
                                setLatestRuntimeLeadsGeneration(
                                    response.data.data
                                )
                            );
                        }

                        return dispatch(
                            setLatestRuntimeLeadsGeneration('Runtime not found')
                        );
                    default:
                        return 'Runtime not found';
                }
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const getDashboardStats = () => {
        return async (dispatch) => {
            try {
                let response = await axiosCall.get(`practices/dashboard`);
                dispatch(setDashboardStats(response.data.data));
                dispatch(
                    setPracticeNotifications(
                        response.data.data.notificationCount
                    )
                );
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const getAssignedUser = (user) => {
        return {
            type: SET_ASSIGNED_USER,
            payload: user,
        };
    };

    const clearHardwareId = (practiceId) => {
        return async (dispatch) => {
            try {
                await axiosCall.delete(
                    `practices/${practiceId}/instances/clear`
                );
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const setSearchCustomIds = (bool) => {
        return {
            type: SET_SEARCH_CUSTOM_IDS,
            payload: bool,
        };
    };

    const setSearchPartnerOfferings = (bool) => {
        return {
            type: SET_SEARCH_PARTNER_OFFERINGS,
            payload: bool,
        };
    };

    const setSearchPracticePims = (bool) => {
        return {
            type: SET_SEARCH_PRACTICE_PIMS,
            payload: bool,
        };
    };

    const setIntermediateEntityCounts = (counts) => {
        return {
            type: SET_INTERMEDIATE_ENTITY_COUNTS,
            payload: counts,
        };
    };

    const fetchIntermediateEntityCounts = (practiceId) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.get(
                    `practices/${practiceId}/intermediateCounts`
                );
                dispatch(setIntermediateEntityCounts(response.data.data));
                return response.data.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(practiceError(errorMsg));
            }
        };
    };

    const setPracticeScheduleModalWorkingPractice = (practice = {}) => {
        return {
            type: SET_SCHEDULE_MODAL_WORKING_PRACTICE,
            payload: practice,
        };
    };

    const setPracticeRelationsModalWorkingPractice = (practice = {}) => {
        return {
            type: SET_RELATIONS_MODAL_WORKING_PRACTICE,
            payload: practice,
        };
    };

    const setPracticeConfigModalWorkingPracticeId = (practiceId = '') => {
        return {
            type: SET_CONFIG_MODAL_WORKING_PRACTICE,
            payload: practiceId,
        };
    };

    return {
        activatePractice,
        addPracticeBookmark,
        addOfferingStep2,
        clearHardwareId,
        createPractice,
        createPracticeInstaller,
        deactivatePractice,
        editPractice,
        fetchIntermediateEntityCounts,
        fetchPractice,
        fetchPracticeRequest,
        fetchPracticesRequest,
        fetchPracticesResult,
        fetchShardRegions,
        getAllPracticeGroups,
        getAllShardRegions,
        getAssignedUser,
        getCurrentPage,
        getDashboardStats,
        getFirstActivePracticeId,
        getFirstStalePracticeId,
        getPractice,
        getPracticeConfig,
        getPracticeConfigForm,
        getPracticeConfiguration,
        getPracticeConfigurationForm,
        getPractices,
        getSomePractices,
        getLatestRuntime,
        getLatestInstanceReportRuntime,
        mutePractice,
        practiceError,
        practiceTabSelected,
        removeAssignedUser,
        removePracticeBookmark,
        removeOfferingsStep2,
        saveBookmarkedPractice,
        saveEditedPracticeInfo,
        savePracticeConfiguration,
        savePracticeInfo,
        searchingForPractices,
        selectPractice,
        selectPracticeToMute,
        selectPracticeToAssignToUser,
        setActiveInactive,
        setActiveTabPractices,
        setAssignedUser,
        setBookmarked,
        setCurrentPage,
        setFilter,
        setFirstActivePracticeId,
        setFirstPracticeReady,
        setFirstStalePracticeId,
        setIncludeTestPractices,
        setIncludeDormantPractices,
        setOnlyShowAssigned,
        setSearchCustomIds,
        setSearchGroups,
        setSearchNotes,
        setSearchPartnerOfferings,
        setSearchPracticePims,
        setLatestRuntimeJobExtraction,
        setLatestRuntimeJobStaging,
        setLatestRuntimeJobIntermediate,
        setLatestRuntimeLeadsGeneration,
        triggerAgentRestart,
        triggerManualPracticeDaylightSync,
        triggerManualPracticeExtraction,
        terminateDataExtraction,
        triggerManualPracticeAttachmentSync,
        triggerManualPracticeAttachmentSyncFromIntermediate,
        terminateAttachmentSync,
        triggerManualPracticeIntermediateLoad,
        triggerManualPracticeStagingLoad,
        triggerManualPracticeReportingSync,
        triggerManualPracticeLeadsGeneration,
        unSelectPractice,
        unmutePractice,
        updatePracticeTab,
        resetOfferingsStep2,
        setPracticeScheduleModalWorkingPractice,
        setPracticeRelationsModalWorkingPractice,
        setPracticeConfigModalWorkingPracticeId,
        closePracticeTab,
        setCurrentPractice,
    };
};

export default initActions;
